<svg-icon
  [src]="'assets/icons/' + type + '/' + name + '.svg'"
  [svgStyle]="size ? { 'width.px': size, 'height.px': size } : { width: '1em', height: '1em' }"
  style="display: block; width: {{ size ? size + 'px' : '1em' }}; height: {{ size ? size + 'px' : '1em' }}"
></svg-icon>
